export const productConfiguration = {
    'business-banking': 'business_banking',
    'alternate-product': 'alternate_product',
    'dynamic-business-banking': 'dynamic_business_banking',
};

export const tealiumConfiguration = {
    'business-banking': {
        siteSection: 'tools',
        subSiteSection: 'product recommender business banking',
    },
    'dynamic-business-banking': {
        siteSection: 'tools',
        subSiteSection: 'product recommender business banking',
    },
};
